import React from 'react'
import Input from 'shared/components/ui/input'
import PropTypes from 'prop-types'
import { cn } from 'shared/util/cn'

const SearchBar = ({ searchItem, onChangeFn, placeHolder, className }) => {
  return (
    <div className={cn('w-full', className)}>
      <Input
        type="search"
        id="search"
        placeholder={placeHolder}
        onChange={(e) => onChangeFn(e.target.value)}
        value={searchItem}
        className="pl-4"
      />
    </div>
  )
}

SearchBar.propTypes = {
  searchItem: PropTypes.string.isRequired,
  onChangeFn: PropTypes.func.isRequired,
  placeHolder: PropTypes.string.isRequired,
  className: PropTypes.string
}

export default SearchBar
